// @ts-nocheck
// These methods belong to every table
import database from "@/database";
import download from "downloadjs";
import XLSX from "xlsx";
// import csvstringify from "csv-stringify";

export default {
  methods: {
    // load & download the records into a csv file
    download() {
      let params = Object.assign({}, this.conditions);
      params = Object.assign(params, { order: this.orderBy });
      this.$Loading.start();
      database
        .search(this.tableDownloadURL || this.tableURL, params, { headers: { Accept: "text/csv" } })
        .then(response => {
          // let content = "sep=,\n" + response.data;
          // download(content, "dataset.csv", "text/csv");
          const file = XLSX.read(response.data, { type: "binary", raw: true });
          XLSX.writeFile(file, "dataset.xlsx");
          this.$Loading.finish();
        })
        .catch(error => {
          this.$Loading.error();
          console.error(error.response);
          this.$Notice.error({
            title: "Error",
            desc: "Results failed to load",
            duration: 8,
          });
        });
    },

    // load the records into the data
    load() {
      let params = Object.assign({}, this.conditions);
      params = Object.assign(params, { order: this.orderBy });
      params = Object.assign(params, { offset: this.page.offset });
      // Page limit
      if (this.page.limit > 0) {
        params = Object.assign(params, { limit: this.page.limit });
      }
      this.$Loading.start();
      database
        .search(this.tableURL, params, {})
        .then(response => {
          this.dataset = response.data;
          this.pagination(response.headers["content-range"]);
          console.log("Results loaded successfully");
          this.$Loading.finish();
        })
        .catch(error => {
          console.error(error.response);
          this.$Notice.error({
            title: "Error",
            desc: "Results failed to load",
            duration: 8,
          });
          this.$Loading.error();
        });
    },
  },
};
